// extracted by mini-css-extract-plugin
var _1 = "OrderPricingStyle-module__bottom____5uKF";
var _2 = "OrderPricingStyle-module__box___dqa9r";
var _3 = "OrderPricingStyle-module__order-pricing___BJGfj";
var _4 = "OrderPricingStyle-module__order-pricing___BJGfj";
var _5 = "OrderPricingStyle-module__sell-all___ixCWq";
var _6 = "OrderPricingStyle-module__sell-all___ixCWq";
var _7 = "OrderPricingStyle-module__top___gM732";
export { _1 as "bottom", _2 as "box", _3 as "order-pricing", _4 as "orderPricing", _5 as "sell-all", _6 as "sellAll", _7 as "top" }
